import {normalizeSearchText} from '../../../../../utils/normalizeSearchText';

export type MatchRange = {start: number; end: number};

/**
 * Finds the range (original-string indices) of the first case- and
 * diacritics-insensitive occurrence of the term inside the text.
 *
 * Normalization can change string length ("á" NFD-decomposes before its mark
 * is stripped), so the text is normalized character by character while
 * recording each normalized character's original index — the match found in
 * normalized space is then mapped back through that record.
 */
export const findMatchRange = (text: string, searchTerm: string): MatchRange | undefined => {
  const normalizedTerm = normalizeSearchText(searchTerm);
  if (!normalizedTerm) {
    return undefined;
  }

  const originIndexes: number[] = [];
  let normalizedText = '';
  let originIndex = 0;
  for (const char of text) {
    const fragment = normalizeSearchText(char);
    for (let i = 0; i < fragment.length; i++) {
      originIndexes.push(originIndex);
    }
    normalizedText += fragment;
    originIndex += char.length;
  }

  const matchStart = normalizedText.indexOf(normalizedTerm);
  if (matchStart === -1) {
    return undefined;
  }
  const matchEnd = matchStart + normalizedTerm.length - 1;
  return {start: originIndexes[matchStart], end: originIndexes[matchEnd] + 1};
};
